// A small per-run "have we already shown this?" flag backed by sessionStorage,
// shared by payroll_run_channel.js and payroll_sheet_errors_channel.js so the
// same key-building/get/set pattern isn't duplicated between them.
const sessionFlag = (name) => {
  const key = (payrollRunId) => `${name}:${payrollRunId}`;

  return {
    isSet: (payrollRunId) => {
      if (!payrollRunId) return false;

      try {
        return sessionStorage.getItem(key(payrollRunId)) === 'true';
      } catch (_) {
        return false;
      }
    },
    set: (payrollRunId) => {
      if (!payrollRunId) return;

      try {
        sessionStorage.setItem(key(payrollRunId), 'true');
      } catch (_) {}
    }
  };
};

export default sessionFlag;
